module.exports = __webpack_public_path__ + "img/pc.d69f4404.png";